<template>
  <div data-testid="disconnect-devices">
    <NavBar>
      <template #left>
        <IconButton
          type="button"
          icon-name="ic_arrow_left"
          @click="goToPreviousStep"
        />
      </template>
      <template #center>
        <span class="navbar-title">Segurança</span>
      </template>
    </NavBar>
    <div class="content">
      <div class="texts">
        <Heading :level="2">Acessar conta sem celular</Heading>
        <BaseText size="md" :color="NebraskaColors.textSecondary">
          Para garantir a segurança da sua conta apenas funções de emergência
          estão disponíveis ao acessar a conta sem celular.
        </BaseText>
      </div>
      <div class="buttons">
        <ButtonBoxDecide
          class="disconnect-devices box-decide-item"
          :label="disconnectDevicesData.label"
          :icon="disconnectDevicesData.icon"
          :secondary-text="disconnectDevicesData.secondaryText"
          :loading="isLoading"
          @click="disconnectDevices"
        />
        <ButtonBoxDecide
          class="disconnect-devices box-decide-item"
          :label="talkToWarrenData.label"
          :icon="talkToWarrenData.icon"
          :secondary-text="talkToWarrenData.secondaryText"
          @click="talkToWarren"
        />
      </div>
    </div>
    <Notification group="wrn-security" />
  </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import {
  NavBar,
  IconButton,
  Heading,
  BaseText,
  ButtonBoxDecide
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  ILoginData,
  disconnectDevices
} from '@/modules/authentication/services/mfa';
import { Notification } from '@/modules/common/components/Notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import { DISCONNECT_DEVICES_ERROR } from '../../../MultiFactorAuthentication/helpers/text-constants/text-constants';
import * as trackEvents from './track-events';

@Component({
  components: {
    NavBar,
    IconButton,
    Heading,
    BaseText,
    ButtonBoxDecide,
    Notification
  }
})
export default class DisconnectDevices extends Vue {
  @Prop({ type: Object, required: true })
  private loginData!: ILoginData;

  private NebraskaColors = NebraskaColors;

  public isLoading = false;

  public disconnectDevicesData = {
    label: 'Desconectar de tudo',
    icon: 'BC0030',
    secondaryText:
      'Esta opção desconecta sua conta em todos os celulares e navegadores conectados e logados.'
  };

  public talkToWarrenData = {
    label: 'Falar com a Warren',
    icon: 'ED0070',
    secondaryText:
      'Se tiver dúvidas, você pode consultar as perguntas frequentes ou falar com nosso atendimento.'
  };

  @Emit('next-step')
  public goToNextStep(step?: string) {
    return step;
  }

  @Emit('previous-step')
  public goToPreviousStep() {
    trackEvents.trackGoBackClick();
  }

  mounted() {
    trackEvents.trackDisconnectDevicesLoad();
  }

  private async disconnectDevices() {
    trackEvents.trackDisconnectAllClick();
    this.isLoading = true;
    try {
      const data = {
        email: this.loginData.email,
        password: this.loginData.password
      };
      await disconnectDevices(data);
      this.goToNextStep();
    } catch {
      this.notificationToast(DISCONNECT_DEVICES_ERROR, NotificationTypes.error);
    } finally {
      this.isLoading = false;
    }
  }

  public talkToWarren() {
    trackEvents.trackTalkToWarrenClick();
    this.goToNextStep('talkWarren');
  }

  private notificationToast(message: string, type: NotificationTypes) {
    this.$notify({
      group: 'wrn-notifications',
      text: message,
      type
    });
  }
}
</script>
<style lang="less" scoped>
.content {
  @navbar-height: 64px;
  min-height: calc(100vh - @navbar-height);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.texts {
  max-width: 34vw;
  min-width: 400px;
}

.buttons {
  display: flex;
  max-width: 35vw;
  min-width: 400px;
  margin-top: @size-spacing-x700;

  .box-decide-item {
    max-width: 280px;
    width: 100%;
  }

  .disconnect-devices {
    margin-right: @size-spacing-x500;
  }
}
</style>
